<template>
<vs-row>
  <vs-col class="w-3/12 pr-6">
    <vx-card no-shadow >
      <div>
        <vs-input class="inputx tree-search-input float-left mr-2" placeholder="Search..." v-model.lazy="searchword" />
        <vs-button color="primary" type="filled" @click="search" class="mb-3">Search</vs-button>
        <v-tree ref="tree" :data="sidebarItems" :draggable="false" :tpl="tpl" :halfcheck="false" :multiple="false"/>
      </div>
    </vx-card>

  </vs-col>
  <vs-col class="w-9/12">
    <vx-card no-shadow >
      <vs-table
        class="pb-wide"
        stripe
        ref="table"
        :data="templates"
        search

        :sst="true"
        :max-items="itemsPerPage">

        <template slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-select autocomplete id="tableSelect" label="" v-model="itemsPerPage" class="w-1/12" >
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in itemsPerPageOptions"/>
          </vs-select>
        </template>

        <template slot="thead">
          <vs-th class="" sort-key="groupName" >
            <vs-col vs-type="flex"  vs-justify="left" >
              No.
            </vs-col>
          </vs-th>
          <vs-th class="" sort-key="groupName" >
            <vs-col vs-type="flex"  vs-justify="center" >
              연동시스템
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              서식함
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              양식명
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              양식유형
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              사용유무
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              등록일
            </vs-col>
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

            <!-- NO. -->
            <vs-td >
              {{ indextr }}
            </vs-td>

            <!-- 연동시스템 -->
            <vs-td >
              {{ data[indextr].system }}
            </vs-td>

            <!-- 서식함 -->
            <vs-td class="text-center">
              {{ data[indextr].box }}
            </vs-td>

            <!-- 양식명 -->
            <vs-td class="text-center">
              {{ data[indextr].name }}
            </vs-td>

            <!-- 양식유형 -->
            <vs-td class="text-center">
              {{ data[indextr].type }}
            </vs-td>

            <!-- 사용유무 -->
            <vs-td class="text-center">
              {{ (data[indextr].isUsed ? '사용' : '사용안함')  }}
            </vs-td>

            <!-- 등록일 -->
            <vs-td class="text-center">
              {{ data[indextr].created_at }}
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>

      <div class="w-full text-right">
        <vs-button class="w-2/12" color="secondary" >등록</vs-button>
      </div>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="(lastPage) ? lastPage : 1"
            v-model="currentPage"></k-pagination>
        </div>
      </div>

    </vx-card>
  </vs-col>
</vs-row>
</template>

<script>
import { VTree}  from 'vue-tree-halower'
import KPagination from '@/views/components/kPagination/kPagination'

export default {
  name: 'Template',
  components: {
    KPagination,
    VTree
  },
  data () {
    return {
      searchword: '',
      sidebarItems: [],
      templates: [],
      itemsPerPage:10,
      itemsPerPageOptions: [
        { text: '10', value: 10 },
        { text: '20', value: 20 },
        { text: '50', value: 50 }
      ],
      lastPage: 4,
      currentPage: 1
    }
  },

  created () {
    this.loadTemplateList()

    this.templates = [
      { system: '인사', box: '공통', name: '경조비 신청서', type: '내부결재', isUsed:true, created_at:'2020.02.02'},
      { system: '문서결재', box: '공통', name: '경조비 신청서', type: '내부결재', isUsed:true, created_at:'2020.02.02'},
      { system: '문서결재', box: '공통', name: '경조비 신청서', type: '내부결재', isUsed:true, created_at:'2020.02.02'},
      { system: '문서결재', box: '공통', name: '경조비 신청서', type: '내부결재', isUsed:true, created_at:'2020.02.02'},
      { system: '문서결재', box: '공통', name: '경조비 신청서', type: '내부결재', isUsed:true, created_at:'2020.02.02'},
      { system: '문서결재', box: '공통', name: '경조비 신청서', type: '내부결재', isUsed:true, created_at:'2020.02.02'},
      { system: '문서결재', box: '공통', name: '경조비 신청서', type: '내부결재', isUsed:true, created_at:'2020.02.02'},
      { system: '문서결재', box: '공통', name: '경조비 신청서', type: '내부결재', isUsed:true, created_at:'2020.02.02'},
      { system: '문서결재', box: '공통', name: '경조비 신청서', type: '내부결재', isUsed:true, created_at:'2020.02.02'}
    ]
  },
  methods: {
    search () {
      this.$refs.tree.searchNodes(this.searchword)
    },

    async loadTemplateList () {
      await this.$store.dispatch('menu/LOAD_MENU_LIST')
      const menuData = JSON.parse(JSON.stringify(this.$store.state.menu.list))
      menuData.forEach((obj) => {
        if (obj.children.length === 0) {
          delete (obj.children)
        }
      })

      const approval = {
        url: null,
        name: '결재',
        icon: 'CheckCircleIcon',
        submenu: [
          {
            url: '/approval-write',
            name: '결재문서 작성',
            slug: 'page-approval-write',
            icon: 'FileIcon'
          },
          {
            url: '/approval-await',
            name: '결재대기함',
            slug: 'page-approval-await',
            icon: 'FileIcon'
          },
          {
            url: '/approval-process',
            name: '결재진행함',
            slug: 'page-approval-process',
            icon: 'FileIcon'
          },
          {
            url: '/approval-complete',
            name: '완료문서함',
            slug: 'page-approval-complete',
            icon: 'FileIcon'
          },
          {
            url: '/approval-reject',
            name: '반려문서함',
            slug: 'page-approval-reject',
            icon: 'FileIcon'
          },
          {
            url: null,
            name: '참조/열람문서함',
            slug: 'faq',
            icon: 'FileIcon'
          }
        ]
      }
      menuData.push(approval)

      this.sidebarItems = [
        {
          name: '카테고리',
          expanded: true,
          children: menuData
        }
      ]
    },
    tpl (...args) {
      const {0: node, 2: parent, 3: index} = args
      let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      return <span>
        <span class={titleClass} domPropsInnerHTML={node.name} onClick={() => {
          this.$refs.tree.nodeSelected(node)
        }}></span>
      </span>
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/tree.scss";

button.btn-async{
  background: rgba(var(--vs-warning),0.15);
}

button.btn-delete{
  background: rgba(var(--vs-danger),0.15);
}
</style>

<style scoped>
.pb-wide{ margin-bottom:1.5rem !important;}
</style>
